import React, { useState } from 'react';
import Button from 'components/Ui/Button';

import { useAppStore } from 'store/useAppStore';
import { useMessengerStore } from 'store/useMessengerStore';
import isHotkey from 'is-hotkey';

const Send = () => {
	// Use app's store
	const socket = useAppStore(state => state.socket);

	// Use messenger's store
	const pending = useMessengerStore(state => state.pending);
	const conversation = useMessengerStore(state => state.conversations.find(c => c.id === state.active));

	// Store message's data
	const [message, setMessage] = useState('');

	// Handle message data change
	const onChange = (event) => {
		const { value } = event.target;
		setMessage(value);
	};

	// Handle enter keypress on textarea
	const onEnter = (event) => {
		if (isHotkey('enter', event)) onSend(event);
	};

	// Handle message sending
	const onSend = (event) => {
		event.preventDefault();

		// Do not allow submittion with empty message
		if (message === '') return;

		if (conversation?.id) {
			// Send new message to conversation
			socket.emit('message', {
				conversationId: conversation?.id,
				message
			});
		} else {
			// Create new conversation with message
			socket.emit('conversation', {
				userId: pending?.id,
				message
			});
		}

		// Update message field
		setMessage('');
	};

	return (
		<form className="p-3 flex space-x-3 items-center bg-neutral-100 dark:bg-neutral-700" onSubmit={onSend}>
			<textarea
				rows="2"
				value={message}
				onChange={onChange}
				onKeyDown={onEnter}
				className="py-1 px-2 flex-1 h-full text-sm text-neutral-700 dark:text-neutral-100 bg-white dark:bg-neutral-600 rounded-lg resize-none whitespace-pre-wrap"
			/>

			<Button
				icon="send"
				submit
				small
				square
				onClick={onSend}
			/>
		</form>
	);
};

export default Send;